export { type ProductTileProps, default as ProductTile } from './ProductTile';
